import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import type { BirthdayAlertBody } from '../alertHover.types'
import { birthdayStyles } from './Birthday.styles'
import { getBirthdayMessage } from '../../../../../../../utils/date.util'

const BirthdayBody: React.FC<{ body: BirthdayAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  const result = getBirthdayMessage(body?.date, t)

  if (!result) return null

  const { message, formatted } = result

  return (
    <Box sx={birthdayStyles.root}>
      <Typography sx={birthdayStyles.message}>
        {message} • {formatted}
      </Typography>
    </Box>
  )
}

export default BirthdayBody
